var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2In(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 11v54H28V46h4v15h27V15H32v15h-4V11h35zM42 50l12.91-12L42 26v10H7v4h35v10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_In.9f24595f.svg";
export { SvgJ2In as ReactComponent };